export const walletUpdate = 'wallet:update';
export const ticketAccepted = 'ticket:accepted';
export const ticketBoost = 'ticket:boost';
export const ticketAcceptedFreeTicket = 'ticket:acceptedfreeticket';
export const ticketRejected = 'ticket:rejected';
export const ticketCancelReason = 'ticket:cancelreason';
export const userRealityCheck = 'user:realitycheck';
export const sessionLogout = 'session:logout';
export const eventUpdate = 'event:update';
export const cashoutOfferUpdate = 'cashout:offerupdate';
export const cashoutAccepted = 'cashout:accepted';
export const cashoutRejected = 'cashout:rejected';
export const userInAppNotification = 'user:inappnotification';
export const obsMoodbarScoreUpdate = 'obs:moodbarscoreupdate';
export const dialogOpen = 'dialog:open';
export const limitUpdated = 'limit:updated';
export const userDetailsWeb = 'user:detailsWeb';
export const offeringOutcome = 'offering:outcome';
export const offeringOffer = 'offering:offer';
export const casinoAction = 'casino:action';
export const paymentsDepositFailure = 'payments:depositfailure';
export const sessionReUnlock = 'session:reunlock';
export const zimplerDepositFailed = 'zimpler-deposit:failed';
export const ticketFeaturedsupercharge = 'ticket:featuredsupercharge';
export const bonusWalletUpdate = 'bonusWallet:update';
